var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.354 2.14604C11.4005 2.19249 11.4375 2.24766 11.4627 2.30841C11.4879 2.36915 11.5009 2.43427 11.5009 2.50004C11.5009 2.56581 11.4879 2.63093 11.4627 2.69167C11.4375 2.75242 11.4005 2.80759 11.354 2.85404L5.70698 8.50004L11.354 14.146C11.4479 14.2399 11.5006 14.3673 11.5006 14.5C11.5006 14.6328 11.4479 14.7602 11.354 14.854C11.2601 14.9479 11.1328 15.0007 11 15.0007C10.8672 15.0007 10.7399 14.9479 10.646 14.854L4.64598 8.85404C4.59941 8.80759 4.56247 8.75242 4.53727 8.69167C4.51206 8.63093 4.49908 8.56581 4.49908 8.50004C4.49908 8.43427 4.51206 8.36915 4.53727 8.30841C4.56247 8.24766 4.59941 8.19248 4.64598 8.14604L10.646 2.14604C10.6924 2.09948 10.7476 2.06253 10.8083 2.03733C10.8691 2.01212 10.9342 1.99915 11 1.99915C11.0657 1.99915 11.1309 2.01212 11.1916 2.03733C11.2524 2.06253 11.3075 2.09948 11.354 2.14604Z",
    fill: "#0D6EFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowBlueIcon);
export default __webpack_public_path__ + "static/media/left_arrow_blue_icon.e43c1cb6e6fb10f7be2e95ab45f660ef.svg";
export { ForwardRef as ReactComponent };